import LocalizedStrings from "react-localization";

export const poolMediaStrings = new LocalizedStrings({
  en: {
    preview: "Preview",
    detail: "Detail",
  },
  fr: {
    preview: "Aperçu",
    detail: "Détail",
  },
});
